import airlineImg from '@assets/landing/section5/airline_img.png';
import cottageImg from '@assets/landing/section5/cottage_img.png';
import csoImg from '@assets/landing/section5/cso_img.png';
import logo1 from '@assets/landing/section5/Logos/logo1.png';
import logo2 from '@assets/landing/section5/Logos/logo2.png';
import logo3 from '@assets/landing/section5/Logos/logo3.png';
import logo4 from '@assets/landing/section5/Logos/logo4.png';
import outsourcingImg from '@assets/landing/section5/outsourcing_img.png';
// Assets
import roundImage2 from '@assets/landing/section5/roundImage2.png';
import travelImg from '@assets/landing/section5/travel_img.png';
import { Box } from '@components/ui/atoms/Box';
import { Container } from '@components/ui/atoms/Container';
import { Flex } from '@components/ui/atoms/Flex';
import { Image } from '@components/ui/atoms/Image';
import { Stack } from '@components/ui/atoms/Stack';
import { Text } from '@components/ui/atoms/Text';
import {
  fadeUp,
  floatHover8,
  floatHover8Reverse,
  slideInRight,
} from '@shared/utils/animationsUtil';
import { useScrollReveal } from '@shared/utils/useScrollReveal';
import React from 'react';

const logos = [logo1, logo2, logo3, logo4];

export const DiverseSupport: React.FC = () => {
  const { isVisible, ref: sectionRef } = useScrollReveal(0.1);

  return (
    <Box id="supported" as="section" bg="#0B0B0F" position="relative" pb="6rem" ref={sectionRef}>
      <Container maxW="container.xl" position="relative" zIndex="3">
        {/* --- Overlapping Testimonial Block --- */}
        <Box
          textAlign="center"
          mt="-3.5rem" // Half of avatar + some spacing to overlap PaySection
          mb="6rem"
          position="relative"
          opacity={isVisible ? 1 : 0}
          animation={isVisible ? `${fadeUp} 0.6s ease-out forwards 0s` : 'none'}
        >
          <Box
            w="100px"
            h="100px"
            borderRadius="full"
            bg="linear-gradient(180deg, #3BCCC5 0%, #3B26B1 100%)"
            mx="auto"
            mb="1rem"
            border="4px solid #364965"
          >
            <Image
              src={roundImage2}
              w="full"
              h="full"
              borderRadius="full"
              objectFit="cover"
              alt="Portrait of Dasho Dorji Dradul"
            />
          </Box>

          <Text color="white" fontWeight="600" fontSize="16px" mb="4px">
            Dasho Dorji Dradul
          </Text>
          <Text color="#5AB1BB" fontSize="13px" fontWeight="600">
            Former Director General
          </Text>
          <Text color="#5AB1BB" fontSize="13px" fontWeight="600" mb="1.5rem">
            Department of Tourism
          </Text>

          <Text
            color="gray.400"
            fontStyle="normal"
            fontSize="14px"
            maxW="480px"
            mx="auto"
            mb="1.5rem"
            lineHeight="1.6"
          >
            &quot;Finally, a digital solution to uplift Bhutan as the world&apos;s premium
            <br />
            and trusted luxury destination!&quot;
          </Text>
        </Box>

        {/* --- Main 3-Column Grid --- */}

        <Box pl="1.25rem" py="0.25rem" position="relative" zIndex="2">
          <Box
            position={{ base: 'relative', lg: 'absolute' }}
            right="0"
            opacity={isVisible ? 1 : 0}
            animation={isVisible ? `${slideInRight} 0.8s ease-out forwards 0.1s` : 'none'}
          >
            <Flex align="center" gap="0.75rem" mb="2rem">
              <Box h="18px" w="4px" bg="primary" opacity="0.5" />
              <Text fontSize="lg" fontWeight="700" color="white">
                We Support a Diverse Range of Users
              </Text>
            </Flex>
          </Box>
        </Box>
        <Flex
          gap={{ base: '2rem', lg: '2.5rem' }}
          direction={{ base: 'column', lg: 'row' }}
          align="flex-start"
        >
          {/* Column 1 */}
          <Stack
            flex="1"
            gap="2.5rem"
            opacity={isVisible ? 1 : 0}
            animation={isVisible ? `${fadeUp} 0.8s ease-out forwards 0s` : 'none'}
          >
            {/* Info Card */}
            <Box bg="white" borderRadius="2xl" p="3rem" display="flex" flexDirection="column">
              <Text
                fontSize="19px"
                fontWeight="800"
                color="#2B244D"
                lineHeight="1.4"
                mb="2rem"
                letterSpacing="-0.01em"
              >
                We take pride in supporting all certified users that pass our registration
                requirements, ensuring that everyone, regardless of business scales or preferences,
                can enjoy a seamless and secure payment experience.
              </Text>

              <Box mb="2.5rem">
                <Text fontSize="12.5px" fontWeight="700" color="#2B244D" mb="1.25rem">
                  We&apos;re trusted by the top businesses
                </Text>
                <Flex align="center">
                  {logos.map((logo, idx) => (
                    <Box
                      key={idx}
                      w="38px"
                      h="38px"
                      borderRadius="full"
                      overflow="hidden"
                      border="2.5px solid white"
                      ml={idx > 0 ? '-12px' : '0'}
                      zIndex={logos.length - idx}
                      boxShadow="sm"
                      animation={
                        isVisible
                          ? `${idx % 2 === 0 ? floatHover8 : floatHover8Reverse} ${3 + idx * 0.5}s ease-in-out infinite ${idx * 0.2}s`
                          : 'none'
                      }
                    >
                      <Image src={logo} alt={`logo-${idx}`} w="full" h="full" objectFit="cover" />
                    </Box>
                  ))}
                </Flex>
              </Box>

              <Text fontSize="12px" color="gray.500" lineHeight="1.6" fontWeight="500">
                Whether you&apos;re an individual, a small business, or a large enterprise, our
                platform is designed to cater to your unique needs. Join us in creating a financial
                ecosystem that finally makes online transactions easy and accessible for Bhutan.
              </Text>
            </Box>
            {/* Travel Operators Card */}
            <Box bg="#E8DFFF" borderRadius="2xl" p="1.25rem" display="flex" flexDirection="column">
              <Box borderRadius="xl" overflow="hidden" mb="1.5rem">
                <Image src={travelImg} alt="Travel Operators" w="full" h="auto" objectFit="cover" />
              </Box>
              <Box px="0.75rem">
                <Text fontSize="15px" color="#3B26B1" mb="1rem">
                  for{' '}
                  <Text as="span" fontWeight="800">
                    Travel Operators
                  </Text>{' '}
                  and{' '}
                  <Text as="span" fontWeight="800">
                    Hotels
                  </Text>
                </Text>
                <Text fontSize="12.5px" color="#5a4d8c" fontWeight="500" lineHeight="1.6" mb="1rem">
                  Travel Operators and hotels holding valid trade licenses from the Department of
                  Tourism may register
                </Text>
                <Flex align="center" gap="0.5rem">
                  <Text fontSize="11px" color="#7a6ca6" fontWeight="500">
                    trusted by 450+ travel operators and hotels
                  </Text>
                  <Flex align="center" gap="4px" ml="auto">
                    <Text fontSize="11px" color="#1A1A1A" fontWeight="800">
                      ★ 4.8
                    </Text>
                  </Flex>
                </Flex>
              </Box>
            </Box>
          </Stack>

          {/* Column 2 */}
          <Stack
            flex="1"
            gap="2.5rem"
            mt={{ base: '0', lg: '12rem' }}
            opacity={isVisible ? 1 : 0}
            animation={isVisible ? `${fadeUp} 0.8s ease-out forwards 0s` : 'none'}
          >
            {/* CSOs Card */}
            <Box bg="#D6E8D5" borderRadius="2xl" p="1.25rem" display="flex" flexDirection="column">
              <Box borderRadius="xl" overflow="hidden" mb="1.5rem">
                <Image src={csoImg} alt="CSOs" w="full" h="auto" objectFit="cover" />
              </Box>
              <Box px="0.75rem">
                <Text fontSize="15px" color="#355034" mb="1rem">
                  for{' '}
                  <Text as="span" fontWeight="800">
                    CSOs
                  </Text>
                </Text>
                <Text fontSize="12.5px" color="#526e51" fontWeight="500" lineHeight="1.6" mb="1rem">
                  CSOs holding valid licenses and approvals for receiving donations
                </Text>
                <Text fontSize="11px" color="#6f8c6d" fontWeight="500">
                  trusted by 5+ CSOs
                </Text>
              </Box>
            </Box>

            {/* Outsourcing Card */}
            <Box bg="#F5E0D8" borderRadius="2xl" p="1.25rem" display="flex" flexDirection="column">
              <Box borderRadius="xl" overflow="hidden" mb="1.5rem">
                <Image src={outsourcingImg} alt="Outsourcing" w="full" h="auto" objectFit="cover" />
              </Box>
              <Box px="0.75rem">
                <Text fontSize="15px" color="#9C4B33" mb="1rem">
                  for{' '}
                  <Text as="span" fontWeight="800">
                    Outsourcing Services
                  </Text>
                </Text>
                <Text fontSize="12.5px" color="#b56f59" fontWeight="500" lineHeight="1.6" mb="2rem">
                  Outsourcing Services companies holding valid business licenses with the Ministry
                  of Economic Affairs may register
                </Text>
                {/* <Text fontSize="11px" color="#cc8d78" fontWeight="500">trusted by 1.6k agents</Text> */}
              </Box>
            </Box>
          </Stack>

          {/* Column 3 */}
          <Stack
            flex="1"
            gap="2.5rem"
            mt={{ base: '0', lg: '6rem' }}
            opacity={isVisible ? 1 : 0}
            animation={isVisible ? `${fadeUp} 0.8s ease-out forwards 0s` : 'none'}
          >
            {/* Airlines Card */}
            <Box bg="#F3DFE5" borderRadius="2xl" p="1.25rem" display="flex" flexDirection="column">
              <Box borderRadius="xl" overflow="hidden" mb="1.5rem">
                <Image src={airlineImg} alt="Airlines" w="full" h="auto" objectFit="cover" />
              </Box>
              <Box px="0.75rem">
                <Text fontSize="15px" color="#863A4D" mb="1rem">
                  for{' '}
                  <Text as="span" fontWeight="800">
                    Airlines
                  </Text>
                </Text>
                <Text fontSize="12.5px" color="#a6586b" fontWeight="500" lineHeight="1.6" mb="2rem">
                  Airlines holding valid business licenses from the Ministry of Economic Affairs may
                  register
                </Text>
                {/* <Text fontSize="11px" color="#c2778a" fontWeight="500">support 45 airlines</Text> */}
              </Box>
            </Box>

            {/* Cottage Goods Card */}
            <Box bg="#DBE8F3" borderRadius="2xl" p="1.25rem" display="flex" flexDirection="column">
              <Box borderRadius="xl" overflow="hidden" mb="1.5rem">
                <Image src={cottageImg} alt="Cottage Goods" w="full" h="auto" objectFit="cover" />
              </Box>
              <Box px="0.75rem">
                <Text fontSize="15px" color="#2B516F" mb="1rem">
                  for{' '}
                  <Text as="span" fontWeight="800">
                    Cottage Goods
                  </Text>
                </Text>
                <Text fontSize="12.5px" color="#4a7394" fontWeight="500" lineHeight="1.6" mb="1rem">
                  Cottage Goods companies holding valid business licenses with the Ministry of
                  Economic Affairs may register
                </Text>
                <Text fontSize="11px" color="#668ea8" fontWeight="500">
                  support 10+ services
                </Text>
              </Box>
            </Box>
          </Stack>
        </Flex>
      </Container>
    </Box>
  );
};

DiverseSupport.displayName = 'DiverseSupport';
